import React from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'
import ibsStore from '../Stores/IbsSurveyStore'
import { getCurrencyPlaceHolder } from '../../helpers'
import { insertRowCtrl } from "../../control"
import { CustomAssetTable } from "../../components/TableComponents/DB/Custom Asset Table/CustomAssetTable"
import SurveyCondensedTable from "../SurveyCondensedTable";
import {NumberFormat, PlaceholderFormat} from "../../Enums/constants";

export const EditTableModal = observer((props) => {
    const closeMandateModal = () => {
        store.showInternalTeamModal = false;
        store.showCustomGroupingModal = false;
    }
    const saveMandateModal = () => {
        store.showInternalTeamModal = false;
        store.showCustomGroupingModal = false;

    }
    const addInternalTeam = () => {
        insertRowCtrl("", "", "FrontOffice")
    }


    const onChange = (name, e) => {
        //setTempPreparerModalContent(name, e.target.value)
    };

    const deleteInternalTeam = (rowID) => {
        console.log(rowID)
    }

    const renderTeamsAvail = () => {
        if (ibsStore.allTableResponses["FrontOffice"]) {
            return ibsStore.allTableResponses["FrontOffice"].map((team, index) =>
                <React.Fragment>

                    <div className="row">
                        <div className="col-md-2">
                        </div>
                        <div className="col-md-4">
                            <input type="text" onChange={(e) => onChange('tempLastName', e)} className="textInput" name={""} value={team.TeamName}/>
                        </div>
                        <div className="col-md-2" >
                            <i class='fa fa-minus-circle del-row-icon' style={{ marginLeft: "80px" }} onClick={()=>deleteInternalTeam(team.RowID)} aria-hidden='true'></i>
                        </div>
                       
                    </div>
                </React.Fragment>

            );
        }
        return
        

    }
    let test = store.showInternalTeamModal ? "Internal Team" : "Custom Groupings"
    let width = store.showInternalTeamModal ? "800" : "1100"
    let currencyPlaceHolderThousandsForHeader = `|${PlaceholderFormat.CURRENCY_THOUSANDS}|`;
    let currencyPlaceHolderMilsForHeader = `|${PlaceholderFormat.CURRENCY_MILS}|`;

    //TODO: Would be nice to maintain tables in one place only
    return (
        <React.Fragment>
            <section className="generalModal">
                <Modal
                    visible={store.showInternalTeamModal || store.showCustomGroupingModal}
                    width={width}
                    height="600"
                    effect="fadeInDown"
                    onClickAway={closeMandateModal} >
                    <div className="internalTeamsModal">
                        <h3> <i className="fa fa-edit"></i> Add/Edit {test} </h3>
                        {store.showInternalTeamModal &&
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-6">
                                        <h6 className="comment-heading">Teams currently available</h6>  &nbsp;  <br />
                                    </div>
                                </div>
                                <SurveyCondensedTable tableName={"FrontOffice"}
                                    addRowBtnName={"Add New Team"}
                                    headers={["TeamName", "Costs", "NumFTE", "RowID", "del"]}
                                    columns={[
                                        { data: 'TeamName' },
                                        { data: 'Costs' },
                                        { data: 'NumFTE' },
                                        { data: 'RowID' },
                                        { data: 'del', className: 'delCol' }
                                    ]}
                                    colWidths={['250px', '170px', '170px', '100px', '75px']}
                                    height={300}
                                    formatting={['', NumberFormat.DECIMAL1, NumberFormat.DECIMAL1]}
                                    nestedHeaders={[
                                        ['Internal team', `Cost ex. <br/> manager fees <br/> (${currencyPlaceHolderThousandsForHeader})`, '# of FTE']
                                    ]} />
                            </React.Fragment>

                        }
                        {store.showCustomGroupingModal &&
                            <CustomAssetTable />
                        }

                       
                        <div className="commentModal addNewRowModal">
                            <button type="button" className="btn btn-close" onClick={saveMandateModal}>Done</button>
                        </div>
                 
                    </div>
                   
                </Modal>
            </section>
        </React.Fragment>
    );

});

export default EditTableModal;

//{ renderTeamsAvail() }
//<button type="button" className="btn btn-close btn-left-align" onClick={addInternalTeam}>Add Team</button>

//<span className="comment-heading">User will have access to the following sections: </span><br /><br />
//
//<button type="button" className="btn btn-close" onClick={addOrUpdateSurveyPreparer}>Save</button>
//    <button type="button" className="btn btn-close" onClick={closeSurveyPreparerModal} >Cancel</button>
//<br />
//    <br />
//    <button type="button" className="btn btn-left-align btn-remove" onClick={() => clickRemoveUser(store.surveyPreparerContent.Id)} >Remove User</button>
//    <button type="button" className="btn btn-left-align" onClick={() => clickResendLink(store.surveyPreparerContent.Id)}>Resend Link</button>

//<button type="button" className="btn btn-close " onClick={closeMandateModal}>Cancel</button>
